





















import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwSpinningProgress } from '@libs-uuif/shared/sw-progress';

const cssPrefix = 'sw-widget-error-component';

@Component({
  components: {
    SwSpinningProgress,
  },
})
export default class SwWidgetErrorComponent extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: String, required: false })
  errorMessage: string;

  created() {
    this.$emit('isLoading', false);
  }
}
